import '../../../css/style.scss';
import '../../../css/theme/discord/style.css';
import { ClientI18nInitiation } from '../../../../shared/scripts/ClientI18n.ts';
import { DiscordMountController } from './DiscordMountController.ts';
const ANDROID_LANDSCAPE_SAFE_AREA_INSET_PX = 75;
const NO_SAFE_AREA_INSET_PX = 0;
class EntryDiscordMount {
    static async init() {
        EntryDiscordMount.setSafeAreaInsets();
        window.addEventListener('resize', ()=>EntryDiscordMount.setSafeAreaInsets());
        await ClientI18nInitiation.init();
        new DiscordMountController();
    }
    static setSafeAreaInsets() {
        const isAndroidUser = navigator.userAgent.includes('Android');
        if (!isAndroidUser) return;
        const safeAreaInset = EntryDiscordMount.getAndroidSafeAreaInset();
        document.documentElement.style.setProperty('--safe-area-inset-right', safeAreaInset);
        document.documentElement.style.setProperty('--safe-area-inset-left', safeAreaInset);
    }
    static getAndroidSafeAreaInset() {
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isPortrait) return `${NO_SAFE_AREA_INSET_PX}px`;
        const browserInset = window.innerWidth - document.documentElement.clientWidth;
        const safeAreaInset = Math.max(browserInset, ANDROID_LANDSCAPE_SAFE_AREA_INSET_PX);
        return `${safeAreaInset}px`;
    }
    constructor(){
        void EntryDiscordMount.init();
    }
}
new EntryDiscordMount();
